import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';

import { Layer } from 'bernie-view';
import { QueryRoute, updateSearch } from 'bernie-core';

import { PropertySummary } from '@shared-ui/lodging-property-details';
import { useDialog } from '@shared-ui/dialog-context';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

import { UitkSheet } from 'uitk-react-sheet';

import { SharedUiHighlightedBenefitsWrapper } from 'src/common/components/infosite/shared-ui/offers/highlighted-benefits-wrapper';
import { SharedUiMap } from 'src/common/components/infosite/shared-ui/details/map-wrapper';
import { SharedUiPropertyReviewsDialog } from '../reviews/shared-ui-property-reviews-dialog';
import { SharedUiUnitsCarouselWrapper } from '../offers/units-carousel-wrapper';
import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

const SummaryWrapper: React.FC<SharedUiWrapperProps> = React.memo(({ inputs }) => {
  const history = useHistory();
  const location = useLocation();
  const triggerReviewRef = React.useRef<HTMLElement | null>(null);

  const onClickMap = React.useCallback(() => updateSearch({ history, location, newParams: { pwaDialog: 'map' } }), [history, location]);

  const onClickReviews = React.useCallback(
    () => updateSearch({ history, location, newParams: { pwaDialog: 'reviews' } }),
    [history, location]
  );

  return (
    <>
      <PropertySummary onClickReviews={onClickReviews} onClickMap={onClickMap} inputs={inputs} triggerRef={triggerReviewRef}>
        <PropertySummary.CarouselComponent>
          <SharedUiUnitsCarouselWrapper />
        </PropertySummary.CarouselComponent>
        <PropertySummary.HighlightedBenefitsComponent>
          <SharedUiHighlightedBenefitsWrapper />
        </PropertySummary.HighlightedBenefitsComponent>
      </PropertySummary>
      <MapDialogWrapper />
      <ReviewsDialogWrapper triggerRef={triggerReviewRef} />
    </>
  );
});

interface SummaryDialogProps {
  currentHotel?: CurrentHotelStore;
  triggerRef?: React.RefObject<HTMLElement>;
}

export const ReviewsDialogWrapper: React.FC<SummaryDialogProps> = ({ triggerRef = null }) => {
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog('reviews', 'pwaDialog');
  const onDialogClose = () => {
    dialogActions.closeDialog();
  };

  return (
    <DialogComponent>
      <UitkSheet type="full" isVisible={isDialogOpen} triggerRef={triggerRef} returnFocusOnClose>
        <SharedUiPropertyReviewsDialog onDialogClose={onDialogClose} />
      </UitkSheet>
    </DialogComponent>
  );
};
ReviewsDialogWrapper.displayName = 'ReviewsDialogWrapper';

export const MapDialogWrapper: React.FC<SummaryDialogProps> = () => {
  const history = useHistory();
  const onCloseDialog = React.useCallback(() => history.goBack(), [history]);

  return (
    <QueryRoute query={{ pwaDialog: 'map' }}>
      <Layer id="infosite-map" onDismiss={onCloseDialog}>
        <SharedUiMap onClose={onCloseDialog} />
      </Layer>
    </QueryRoute>
  );
};
MapDialogWrapper.displayName = 'MapDialogWrapper';

export const SharedUiSummaryWrapper = withSharedUiPropertyDetails<SharedUiWrapperProps>(SummaryWrapper);
SharedUiSummaryWrapper.displayName = 'SharedUiSummaryWrapper';
